import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('sublet', () => ({
    theme: ref('light'),
    stripe: ref({
        accountCreatePending: undefined,
        accountLinkCreatePending: undefined,
        paymentIntent: {},
        setupIntent: {},
        completePaymentIntents: [],
        completeSetupIntents: [],
    }),
    updatedAt: ref({

    }),
    config: ref({}),
    apikeys: ref([]),
}),
    {

        persist: {
            debug: false,
        }
    }
)